export const saveNewVendor = (data) => {
  return { type: "SAVE_NEW_VENDOR", data: data };
};
export const saveVendorProducts = (data) => {
  return { type: "SAVE_VENDOR_PRODUCTS", data: data };
};
